module.exports = __webpack_public_path__ + "img/31.a8a563b5.webp";